module.exports = __webpack_public_path__ + "img/blue.4a7d589f.png";